import { action } from 'typesafe-actions';

import { DeliveryMethodsTypes, IDeliveryIntegration } from './types';

export const loadRequest = () => action(DeliveryMethodsTypes.LOAD_REQUEST);
export const loadSuccess = (data: IDeliveryIntegration[]) =>
  action(DeliveryMethodsTypes.LOAD_SUCCESS, data);
export const loadFailure = () => action(DeliveryMethodsTypes.LOAD_FAILURE);
